import { TimelineStepStatus } from '../types.js';

function animationStepStatus(step, status, animationStep, currentStepNumber, stepsCount) {
  if (status) {
    return status;
  }
  if (animationStep === step && currentStepNumber === animationStep && currentStepNumber < stepsCount) {
    return TimelineStepStatus.InProgress;
  }
  if (animationStep >= step) {
    return TimelineStepStatus.Success;
  }
}

export { animationStepStatus as default };
